import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { familyApi } from "../services/api";

export default function FamilyInvitePage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { user, loading, refreshUser } = useAuth();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState("");
  const [accepting, setAccepting] = useState(false);

  useEffect(() => {
    if (!token) return;
    familyApi.getInvite(token)
      .then(setInvite)
      .catch(err => setError(err.message || "Invite link is not available."));
  }, [token]);

  async function acceptInvite() {
    setAccepting(true);
    setError("");
    try {
      await familyApi.acceptInvite(token);
      await refreshUser?.();
      navigate("/app/family");
    } catch (err) {
      setError(err.message || "Could not accept this invite.");
    } finally {
      setAccepting(false);
    }
  }

  useEffect(() => {
    if (!loading && user && invite && !accepting) {
      acceptInvite();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, user, invite]);

  const email = invite?.invite?.email || "";
  const registerUrl = `/register?invite=${encodeURIComponent(token || "")}${email ? `&email=${encodeURIComponent(email)}` : ""}`;
  const loginUrl = `/login?invite=${encodeURIComponent(token || "")}${email ? `&email=${encodeURIComponent(email)}` : ""}`;

  return (
    <div className="hm-auth-shell">
      <div className="hm-auth-card">
        <div className="hm-auth-brand"><strong>HouseMind</strong></div>
        <h1 className="hm-auth-title">Family invite</h1>

        {error && <div className="hm-auth-error">{error}</div>}

        {!error && !invite && <p className="hm-auth-hint">Checking invite...</p>}

        {invite && (
          <>
            <p className="hm-auth-hint" style={{ fontSize: 15, lineHeight: 1.55 }}>
              <strong>{invite.inviter_name || "Someone"}</strong> invited you to join{" "}
              <strong>{invite.workspace_name || "their HouseMind Family plan"}</strong>.
            </p>

            {loading || accepting ? (
              <button type="button" className="hm-auth-btn" disabled>
                {accepting ? "Adding you..." : "Checking account..."}
              </button>
            ) : user ? (
              <button type="button" className="hm-auth-btn" onClick={acceptInvite}>
                Accept invite
              </button>
            ) : (
              <div className="hm-auth-form">
                <Link to={registerUrl} className="hm-auth-btn" style={{ textAlign: "center", textDecoration: "none" }}>
                  Create account
                </Link>
                <Link to={loginUrl} className="hm-auth-link" style={{ textAlign: "center" }}>
                  Already have an account? Sign in
                </Link>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
